import Cookies from 'js-cookie'
import { on } from 'delegated-events'

const siteHeader = document.querySelector('.site-header')
const siteMenu = document.querySelector('.site-menu')
const siteSearch = document.querySelector('.site-search')

const openMenu = () => {
  document.documentElement.classList.add('js-site-menu-open')
}

const closeMenu = () => {
  document.documentElement.classList.remove('js-site-menu-open')

  if (siteMenu) {
    siteMenu.querySelectorAll('.is-active').forEach((el) => {
      const trigger = el.querySelector('[data-slide-toggle]')
      const target = document.getElementById(trigger.getAttribute('aria-controls'))

      target.style = null
      trigger.setAttribute('aria-expanded', 'false')
      el.classList.remove('is-active')
    })
  }
}

const toggleSearch = () => {
  if (document.documentElement.classList.contains('js-site-search-open')) {
    document.documentElement.classList.remove('js-site-search-open')

    siteSearch.querySelector('form').reset()
  } else {
    document.documentElement.classList.add('js-site-search-open')

    siteSearch.querySelector('input').focus()
  }
}

const handleSiteLogo = async () => {
  const siteLogoVideo = document.querySelector('.site-logo-video')

  if (siteLogoVideo) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      siteLogoVideo.classList.add('opacity-0')
    }

    try {
      await siteLogoVideo.play()
    } catch (err) {
      siteLogoVideo.classList.add('opacity-0')
    }

    siteLogoVideo.addEventListener('ended', () => {
      siteLogoVideo.classList.add('opacity-0')
    })

    if (siteLogoVideo.dataset.setCookie) {
      if (!Cookies.get('ucm_logo_video')) {
        Cookies.set('ucm_logo_video', true, {
          expires: 1,
        })
      }
    }
  }
}

export default {
  init: () => {
    const scrollPixel = document.querySelector('.scroll-pixel')

    if (scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle('is-stuck', e.intersectionRatio < 1),
        {
          threshold: [1],
        }
      )

      observer.observe(document.querySelector('.scroll-pixel'))
    }

    window.addEventListener('click', (e) => {
      if (e.target.closest('.site-menu-mobile-screen') && !e.target.closest('.site-menu-mobile')) {
        closeMenu()
      }
    })

    on('click', '.site-menu-open', openMenu)
    on('click', '.site-menu-close', closeMenu)
    on('click', '.site-menu-screen', closeMenu)
    on('click', '.site-search-trigger', toggleSearch)

    handleSiteLogo()
  },
}
